import Initial from "./Initial";
import ErrorMessage from "./share/TopModal";
import { AxiosInstance } from "axios";
import { Card, Layout, Page } from "@shopify/polaris";
import { PlayCircleIcon, StoreIcon } from "@shopify/polaris-icons";
import { t } from "../query/share";
import HeaderWithIcon from "./share/HeaderWIthIcon";
import { pageNames, usePos } from "./hooks/pos";
import TopHeader from "./header/TopHeader";
import { useBase } from "./hooks/base";
import { useModals } from "./hooks/modals";
import EmptyLoading from "./EmptyLoading";
import OnlineStore, { themesType } from "./OnlineStore";
import { useEffect, useState } from "react";

const Main = (props: { authAxios: AxiosInstance }) => {
  const modalsStates = useModals();
  const baseStates = useBase();
  const posStates = usePos();
  const { pos, changePos } = posStates;
  const [themes, setThemes] = useState<themesType[]>([]);

  pos.page === pageNames.loading &&
    window.addEventListener("popstate", (e) => {
      e.preventDefault();
      const [_, page, index] = window.location.pathname.split("/");
      changePos({
        page: pageNames[page as keyof typeof pageNames],
        index: index !== undefined && index !== "" ? Number(index) : undefined,
        noPush: true,
      });
      modalsStates.changeModals({ open: false });
      return;
    });

  useEffect(() => {
    if (pos.page === pageNames.top) {
      window.scrollTo(0, pos.scroll.y);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pos]);

  const allState = {
    ...props,
    ...modalsStates,
    ...posStates,
    ...baseStates,
    ...modalsStates,
  };

  return (
    <>
      {pos.page === pageNames.loading && <Initial {...allState} />}
      {pos.page !== pageNames.loading && <TopHeader {...allState} />}
      {pos.page === pageNames.loading && <EmptyLoading />}
      {pos.page === pageNames.top && (
        <Page>
          <Layout>
            <Layout.Section>
              <HeaderWithIcon
                title={`${t("動画で設定の仕方を確認", "Check how to set it up in the video.")}`}
                source={PlayCircleIcon}
              />
              <Card>
                <div style={{ textAlign: "center" }}>
                  <iframe
                    width="100%"
                    style={{ maxWidth: 560, minHeight: 315 }}
                    src={`https://www.youtube.com/embed/${t("nbQ9_3wG0Ik", "OYgWOyQm0XI")}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Card>
            </Layout.Section>
            <Layout.Section>
              <HeaderWithIcon
                title={`${t("オンラインストアへ反映", "OnlineStore")}`}
                source={StoreIcon}
              />
              <OnlineStore {...allState} {...{ themes, setThemes }} />
            </Layout.Section>
            <Layout.Section />
          </Layout>
        </Page>
      )}

      {modalsStates.modals.open && <ErrorMessage {...allState} />}

      {/* <TestButton {...allState} /> */}
      <div style={{ paddingBottom: 50 }} />
    </>
  );
};
export default Main;
